define('core/views/media/UploadsProgressSubView',[
    'backbone',

    'core/templates/postMediaUploadProgress',
], function (
    Backbone,

    postMediaUploadProgressTemplate
) {
    'use strict';

    // View to display progress of one or more uploads
    var UploadsProgressSubView = Backbone.View.extend({
        initialize: function () {
            this.collection = new Backbone.Collection();
            this.listenTo(this.collection, 'add remove change', this.render);
        },

        hasVisible: function () {
            return Boolean(this.collection.length);
        },

        render: function () {
            this.$el.html(postMediaUploadProgressTemplate({
                collection: this.collection.toJSON(),
            }));
            return this;
        },
    });

    return UploadsProgressSubView;
});

